module.exports = __webpack_public_path__ + "static/img/07_訂餐服務.4289ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/07_訂餐服務.png
// module id = Ys8o
// module chunks = 1